module.exports = __webpack_public_path__ + "static/media/irs-logo.1c38fb9d.png";